import React, { useState, useEffect, useGlobal } from "reactn";
import axios from "axios";
import BaseModal from "./baseModal/BaseModal";
import { GET_HTML } from "./baseModal/FieldTypes";
import { toast } from "react-toastify";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";

const ReshuffleModal = ({ onClose, onApply, currentValue = "", mode = "name", listingType = "programs" }) => {
  const global = useGlobal()[0];
  const [isGenerating, setIsGenerating] = useState(false);
  const [items, setItems] = useState([]);
  const [liked, setLiked] = useState([]);
  const [disliked, setDisliked] = useState([]);
  const [ellipsis, setEllipsis] = useState('.');

  useEffect(() => {
    generateItems();
  }, []);

  useEffect(() => {
    if (isGenerating) {
      let i = 0;
      const seq = ['.', '..', '...'];
      const id = setInterval(() => {
        i = (i + 1) % seq.length;
        setEllipsis(seq[i]);
      }, 500);
      return () => clearInterval(id);
    } else {
      setEllipsis('...');
    }
  }, [isGenerating]);

  const toggleLike = (val) => {
    setLiked(prev => prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]);
    setDisliked(prev => prev.filter(v => v !== val));
  };
  const toggleDislike = (val) => {
    setDisliked(prev => prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]);
    setLiked(prev => prev.filter(v => v !== val));
  };

  const generateItems = async () => {
    setIsGenerating(true);
    try {
      const base = `${process.env.REACT_APP_API}/partners/${listingType}`;
      const endpoint = mode === "name"
        ? (listingType === "events"
            ? `${base}/generate-event-names`
            : listingType === "virtual"
              ? `${base}/generate-virtual-names`
              : listingType === "parties"
                ? `${base}/generate-party-names`
                : `${base}/generate-program-names`)
        : (listingType === "events"
            ? `${base}/generate-event-descriptions`
            : listingType === "virtual"
              ? `${base}/generate-virtual-descriptions`
              : listingType === "parties"
                ? `${base}/generate-party-descriptions`
                : `${base}/generate-program-descriptions`);

      const feedback = mode === "name"
        ? { likedNames: liked, dislikedNames: disliked }
        : { likedDescriptions: liked, dislikedDescriptions: disliked };

      const payload = {
        partnerId: global.organizationInfo.partnerId,
        count: 5,
        feedback
      };
      
      if (mode === "description" && listingType === "virtual") {
        payload.virtualName = currentValue || "Virtual Program";
      }
      
      if (mode === "description" && listingType === "parties") {
        payload.partyName = currentValue || "Party Event";
      }

      const resp = await axios.post(endpoint, payload);

      if (resp.data.success) {
        const data = resp.data.data || [];
        if (Array.isArray(data)) {
          setItems(data);
        } else {
          console.warn("Expected array but got:", data);
          setItems(Object.values(data).filter(val => typeof val === 'string') || []);
        }
      } else {
        toast.error(`Failed to generate ${mode === "name" ? "names" : "descriptions"}`);
        setItems([]);
      }
    } catch (e) {
      console.error("Error generating:", e);
      toast.error(`Failed to generate ${mode === "name" ? "names" : "descriptions"}`);
      setItems([]);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleShuffle = () => generateItems();

  const listFunc = () => (
    <div style={{ marginBottom: "20px", height: "100%", display: "flex", flexDirection: "column" }}>
      <div style={{ fontSize: "17px", color: "#666", marginBottom: "8px" }}>
        Like/dislike suggestions to curate the best list of options.
      </div>

      <div style={{ flex: "1", display: "flex", flexDirection: "column", gap: "8px" }}>
        {items.map((val, idx) => {
          const isLiked = liked.includes(val);
          const isDisliked = disliked.includes(val);
          return (
            <div key={idx} style={{
              padding: "10px",
              borderRadius: "6px",
              backgroundColor: "#fff",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flex: "1"
            }}>
              <span style={{ fontSize: "14px", fontWeight: 400, color: "#333", flex: 1, whiteSpace: "pre-wrap" }}>
                {val}
              </span>

              <button
                style={{
                  backgroundColor: "transparent",
                  color: isLiked ? "#28a745" : "#666",
                  border: "none",
                  borderRadius: "3px",
                  padding: "6px",
                  fontSize: "16px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  marginLeft: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "32px",
                  height: "32px"
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f8f9fa"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
                onClick={() => toggleLike(val)}
                title={`Like this ${mode}`}
              >
                <FaThumbsUp />
              </button>

              <button
                style={{
                  backgroundColor: "transparent",
                  color: isDisliked ? "#dc3545" : "#666",
                  border: "none",
                  borderRadius: "3px",
                  padding: "6px",
                  fontSize: "16px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  marginLeft: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "32px",
                  height: "32px"
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f8f9fa"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
                onClick={() => toggleDislike(val)}
                title={`Dislike this ${mode}`}
              >
                <FaThumbsDown />
              </button>

              <button
                style={{
                  backgroundColor: "#3B4EFF",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                  transition: "background-color 0.2s ease",
                  marginLeft: "8px"
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#2a3bd9"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#3B4EFF"; }}
                onClick={() => { onApply(val); onClose(); }}
                disabled={isGenerating}
              >
                Apply
              </button>
            </div>
          );
        })}
      </div>

      {isGenerating && (
        <div style={{ textAlign: "center", padding: "20px", color: "#666", fontStyle: "italic" }}>
          {`Activating magic wizard${ellipsis}`}
        </div>
      )}
    </div>
  );

  const getFields = () => ([
    { type: GET_HTML, data: { gethtml: listFunc } }
  ]);

  const getButtons = () => ([
    {
      name: <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>Re-shuffle</span>,
      handleClick: handleShuffle,
      buttonColour: "#3B4EFF",
      textColour: "#fff",
      disabled: isGenerating
    }
  ]);

  const getBaseModalProps = () => ({
    title: mode === "name" 
    ? (listingType === "events" ? "Generated Event Names" 
        : listingType === "virtual" ? "Generated Virtual Program Names" 
        : listingType === "parties" ? "Generated Party Names"
        : "Generated Program Names") 
    : (listingType === "events" ? "Generated Event Descriptions" 
        : listingType === "virtual" ? "Generated Virtual Program Descriptions" 
        : listingType === "parties" ? "Generated Party Descriptions"
        : "Generated Program Descriptions"),
    fields: getFields(),
    buttons: getButtons(),
    handleClose: onClose,
    height: "60vh",
    midSectionHeight: "45vh"
  });

  return <BaseModal {...getBaseModalProps()} />;
};

export default ReshuffleModal; 